import api from './index'
import type { ApiResponse } from '@/types'

export interface ScheduleRulePayload {
  name: string
  description?: string
  templateId: string
  templateVersionId?: string
  projectId?: string
  timezone: string
  frequency: string
  interval?: number
  startDate: string
  endDate?: string | null
  config?: Record<string, unknown>
}

export const listScheduleRules = async (
  params: { templateId?: string; projectId?: string },
): Promise<ApiResponse<{ rules: ScheduleRuleSummary[] }>> => {
  const response = await api.get('/forms/schedules', { params })
  return response.data
}

export interface ScheduleRuleSummary {
  id: string
  name: string
  description?: string | null
  timezone: string
  frequency: string
  interval: number
  startDate: string
  endDate?: string | null
  nextRunAt?: string | null
  status: string
}

export const createScheduleRule = async (
  payload: ScheduleRulePayload,
): Promise<ApiResponse<ScheduleRuleSummary>> => {
  const response = await api.post('/forms/schedules', payload)
  return response.data
}
